import fetchApi from './apiFetch';
import logActions from './logActions';

const devSagas = process.env.NODE_ENV === 'development' ? [logActions] : [];

export default [
  fetchApi,
  ...devSagas,
];
